import { SvgAdd } from '@/components/icons';
import { Accounts } from './Accounts';
import { BudgetName } from './BudgetName';
import { PrimaryButtons } from './PrimaryButtons';

type SidebarProps = {
  floating: boolean;
  onToggleFloating: () => void;
  onAddAccount: () => void;
};

/** Port of `sidebar/Sidebar.tsx` inside a `SidebarShell` of fixed 240px. */
export function Sidebar({
  floating,
  onToggleFloating,
  onAddAccount,
}: SidebarProps) {
  return (
    <aside
      className={
        floating
          ? 'scrollable-dark absolute inset-y-0 left-0 z-40 flex w-[240px] flex-col bg-sidebar-background text-sidebar-item-text shadow-large'
          : 'scrollable-dark flex h-full w-[240px] shrink-0 flex-col bg-sidebar-background text-sidebar-item-text'
      }
      data-testid="sidebar"
    >
      <BudgetName floating={floating} onToggleFloating={onToggleFloating} />
      <div className="flex min-h-0 flex-1 flex-col">
        <PrimaryButtons />
        <Accounts />
      </div>
      <button
        type="button"
        onClick={onAddAccount}
        data-testid="sidebar-add-account"
        className="m-0 flex shrink-0 items-center gap-2 px-[19px] py-[9px] text-left text-md font-medium text-sidebar-item-text hover:bg-sidebar-item-background-hover"
      >
        <SvgAdd width={15} height={15} />
        添加账户
      </button>
    </aside>
  );
}
